module.exports = __webpack_public_path__ + "static/media/scotia.16d0bcd3.png";